<template>
  <div class="component_6 my_app_tabs_data">
    <div class="component_6 pa-20">
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <h2 class="nec_title pb-2">{{ $t('component.search_application.fields.notice_applicant_representative') }}</h2>
          <h2 class="nec_title">{{ $t('component.search_application.fields.sub_title') }}</h2>
        </v-col>
        <v-col cols="12" class="pa-0 mt-20">
          <v-textarea
            outlined
            v-model="application_nos"
            class="ft-size12 email"
            placeholder="EG/P/YYYY/#####"
          ></v-textarea>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn
              class="ft-size12 text-capitalize br_none new__check__btn"
              dense
              color="#a01c2a"
              dark
              width="95"
              height="40"
              @click="fnCheck()"
            >
              {{ $t('common.button.check') }}
            </v-btn>
          </div>

        </v-col>
      </v-row>
    </div>

    <h2 v-show="applicant_show_yn && isChecked" class="m_title solo mt-30">{{ $t('component.application_information.application_information') }}</h2>
    <div class="component_6 pa-20 pt-0" v-show="applicant_show_yn && isChecked">
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-data-table
            :headers="$getHeaderType2(headerTxt, headersEn, headersAr)"
            :items="applications"
            hide-default-footer
            disable-sort
            disable-pagination
            class="elevation-0 ft-size12"
            :mobile-breakpoint="mobileBreakPoint"
            item-key="seq"
            v-model="selectedItem"
            single-select
          >
            <template v-slot:item.res_msg_ar="{ item }">
              <span v-if="item.res_code !== '200'"><v-icon small color="#a01c2a">mdi-alert</v-icon></span>
              <span v-if="item.res_code !== '200'">{{ item.res_msg_ar }}</span>
            </template>
            <template v-slot:item.res_msg_en="{ item }">
              <span v-if="item.res_code !== '200'"><v-icon small color="#a01c2a">mdi-alert</v-icon></span>
              <span v-if="item.res_code !== '200'">{{ item.res_msg_en }}</span>
            </template>
            <template v-slot:item.seq="{ item }">
              <v-btn icon @click="fnRemoveItem(item.application_no)">
                <v-icon small color="#a01c2a">mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  props : {
    applicant_show_yn : Boolean,
    service_type_code : String
  },
  data(){
    return {
      mobileBreakPoint : 0,
      application_nos : '',
      isChecked : false,
      chkResult : false,
      errorText : null,

      headerTxt : {
        prefix : 'component.search_application.fields.',
        txt : [ 'application_no', 'title','representative', '' ]
      },

      headersAr : [
        { text: this.$t('component.search_application.fields.application_no'), align: 'center', value:'application_no', width: 120 },
        { text: this.$t('component.search_application.fields.title'), align: 'center', value:'title_ar' },
        { text: this.$t('component.search_application.fields.representative'), align: 'center', value:'current_user_name_ar' },
        { text: '', align: 'center', value: 'seq', width: 40 },
      ],

      headersEn : [
        { text: this.$t('component.search_application.fields.application_no'), align: 'center', value:'application_no', width: 120 },
        { text: this.$t('component.search_application.fields.title'), align: 'center', value:'title_en' },
        { text: this.$t('component.search_application.fields.representative'), align: 'center', value:'current_user_name_en' },
        { text: '', align: 'center', value: 'seq', width: 40 },
      ],

      applications : [],
      selectedItem: [],

      application : {
        seq : '',
        application_no : '',
        filing_date : '',
        original_application_no : '',
        applicant_type_code : '',
        title_ar : '',
        title_en : '',
        receipt_date : '',
        first_priority_date : '',
        exhibition_date : '',
        exhbition_notes : '',
        publication_date : '',
        domain_type_code : '',
        grant_no : '',
        grant_date : '',
        ind_granted : '',
        expiration_date : '',
        international_application_no : '',
        international_filing_date : '',
        pct_publication_country_code : '',
        pct_publication_no : '',
        pct_publication_type : '',
        pct_publication_date : '',
        last_description_page : '',
        last_claims_page : '',
        ind_novelity : '',
        ind_inventive : '',
        ind_industrial : '',
        status_seq : '',
        abstract_ar : '',
        abstract_en : '',
        remark : '',
        domain_sub_type_code : '',
        applicant_name_list_ar : '',
        applicant_name_list_en : '',
        certification_file_key : '',
        ind_micro_org_protection : '',
        receipt_no : '',
        ind_same_app_inv : ''
      }

    }
  },
  watch: {
    application_nos(){
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.applications = []
      this.$emit('change')
    }
  },
  mounted() {
    if(utils.isNull(this.applicant_show_yn)){
      this.applicant_show_yn = true
    }
    this.fnInitSearch()
  },
  methods: {
    fnInitSearch(){
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.applications = []
      this.application_nos = ''
    },

    fnCheck(){
      if(this.application_nos){
        let param_arr = []

        //쉼표, 공백, 줄바꿈 을 이용해서 split한다..
        let application_no_str = this.application_nos
        let comma_arr = application_no_str.split(',')

        comma_arr.forEach( item_comma => {
          let space_arr = item_comma.split(' ')

          space_arr.forEach( item_space => {
            let line_arr = item_space.split('\n')

            line_arr.forEach( item_line => {
              let item_arr = item_line.split('\t')

              item_arr.forEach(item => {
                if(item.length != 0){
                  param_arr.push(item)
                }
              })
            })
          })
        })

        if(param_arr.length > 0){
          this.selectedItem = []
          requestApi({
            url: '/applications/searches?service_type_code='+this.service_type_code+'&application_nos='+param_arr.join('&application_nos='),
            method: 'GET',
            callback: (res) => {
              if (res.res_code === '200') {
                this.isChecked = true
                this.applications = res.data.list

                this.fnChkApplications()
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnCheck()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      }
    },

    fnRemoveItem(application_no){
      for(let i=0; i<this.applications.length; i++){
        if(this.applications[i].application_no == application_no){
          this.applications.splice(i, 1)
        }
      }

      //변경이 일어날때 마다 체크를 다시 해야 한다.
      this.fnChkApplications()
    },

    fnChkApplications(){
      this.chkResult = true
      this.selectedItem = []

      this.applications.forEach(item => {
        if (item.res_code !== '200') {
          this.selectedItem.push(item)
        }
      })

      let chked_item = {
        chkResult : this.chkResult,
        applications : this.applications
      }

      this.$emit('success', chked_item)
    }
  }
}

</script>